import { Box } from '@mui/material';
import { Outlet } from 'react-router-dom';
import Poe1Navbar from '../Components/layout/Poe1Navbar';

function Poe1Layout() {
  return (
    <>
      <Poe1Navbar />
      <Box component="main" className="app-container" sx={{ py: 3 }}>
        <Outlet />
      </Box>
    </>
  );
}

export default Poe1Layout;
